import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Label,
  FormFeedback,
  Form,
} from "reactstrap";
import shortid from "shortid";
import { useFormik } from "formik";
import { FIVE_NUMBER_REGEX } from "../../../../utils/constants/ValidationRegexs";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { getAlert } from "../../../../utils/functions/CustomFunctions";

function LOCATION_CODE_CRUD(props) {
  const { callback, locationCodeFromResponse, isAdd } = props;
  // console.log("formvalues", values);

  //Initial Location Code
  const initialLocationCode = shortid.generate();
  const [locationCodeIndexes, setLocationCodeIndexes] = useState([
    initialLocationCode,
  ]);
  const [formData, setFormData] = useState({
    [`location_code_${initialLocationCode}`]: "",
    [`description_${initialLocationCode}`]: "",
  });

  //Remove Document
  const removeDocument = (event) => {
    const element = event.currentTarget.dataset.element_id;
    const filteredCodes = locationCodeIndexes.filter(
      (record) => record !== element
    );
    setFormData({
      ...formData,
      [`location_code_${element}`]: undefined, //remove from object
      [`description_${element}`]: undefined, //remove from object
    });
    setLocationCodeIndexes([...filteredCodes]);
  };

  //Dyanmic Schema for Location Code CRUD
  let validationSchema = Yup.object({});
  locationCodeIndexes.forEach((element) => {
    validationSchema = validationSchema.shape({
      [`location_code_${element}`]: Yup.string()
        .trim()
        .required("Location code id is required"),
      // .matches(FIVE_NUMBER_REGEX, "Enter valid location code id"),
    });
  });

  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    setErrors,
    setFieldTouched,
    handleBlur,
    setFieldValue,
  } = useFormik({
    initialValues: {
      ...formData,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });

  //On Submit
  const saveFormValues = async (formValues) => {
    const location_code_array = [];
    locationCodeIndexes.forEach((element) => {
      location_code_array.push({
        locationCode: formValues[`location_code_${element}`],
        description: formValues[`description_${element}`],
      });
    });
    var duplicateRecord = Object.values(
      location_code_array.reduce((c, v) => {
        let k = v.locationCode;
        c[k] = c[k] || [];
        c[k].push(v);
        return c;
      }, {})
    ).reduce((c, v) => (v.length > 1 ? c.concat(v) : c), []);
    if (duplicateRecord.length > 0) {
      Swal.fire(getAlert("error", "No Duplicate Location Code Allowed"));
    } else {
      callback(location_code_array);
    }
  };
  //Add New Location Code Row
  const AddNewLocationCode = () => {
    const newElementId = shortid.generate();
    setFormData({
      ...formData,
      ...values,
      [`location_code_${newElementId}`]: "",
      [`description_${newElementId}`]: "",
    });
    locationCodeIndexes.push(newElementId);
    setLocationCodeIndexes([...locationCodeIndexes]);
    setErrors({ ...errors });
  };

  // console.log("add values", values);
  // console.log("errors", errors);
  // console.log("touched", touched);

  useEffect(() => {
    if (locationCodeFromResponse && locationCodeFromResponse.length) {
      const indexArray = [],
        locationObj = {};
      locationCodeFromResponse.forEach(({ description, locationCode }) => {
        const newElementId = shortid.generate();
        indexArray.push(newElementId);
        locationObj[`location_code_${newElementId}`] = locationCode;
        locationObj[`description_${newElementId}`] = description;
      });
      setFormData({
        ...locationObj,
      });
      setLocationCodeIndexes([...indexArray]);
    }
  }, [locationCodeFromResponse]);

  useEffect(() => {
    if (isAdd) {
      setLocationCodeIndexes([initialLocationCode]);
    }
  }, [isAdd]);
  return (
    <Fragment>
      <Form form="true" onSubmit={handleSubmit}>
        {locationCodeIndexes.map((element, index) => (
          <Row key={`document_list_${index}`}>
            <Col md={1} />
            <Col md={3}>
              <FormGroup>
                <Label>Location Code *</Label>
                <Input
                  type="text"
                  name={`location_code_${element}`}
                  placeholder="Enter Location Code"
                  invalid={
                    errors[`location_code_${element}`] &&
                    touched[`location_code_${element}`]
                      ? true
                      : false
                  }
                  // onChange={handleChange}
                  onChange={({ target: { value } }) => {
                    setFieldTouched(`location_code_${element}`, true);
                    setFieldValue(`location_code_${element}`, value);
                  }}
                  value={values[`location_code_${element}`]}
                />
                <FormFeedback>
                  {errors[`location_code_${element}`] &&
                  touched[`location_code_${element}`]
                    ? errors[`location_code_${element}`]
                    : ""}
                </FormFeedback>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Description</Label>
                <Input
                  type="text"
                  name={`description_${element}`}
                  placeholder="Enter Description"
                  onChange={handleChange}
                  value={values[`description_${element}`]}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              {locationCodeIndexes.length > 1 && (
                <i
                  className="fas fa-trash"
                  title="Remove"
                  data-element_id={element}
                  style={{
                    color: "#c72e39",
                    margin: "12px",
                    marginTop: "2rem",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={removeDocument}
                />
              )}
            </Col>
          </Row>
        ))}
        <Row>
          <Col md={1} />
          <Col md={3}>
            <Button color="primary" onClick={AddNewLocationCode}>
              <i className="fas fa-plus" /> Location Code
            </Button>
          </Col>
          <Col md={5} style={{ marginLeft: "-3rem" }}>
            <Button color="success" type="submit">
              <i className="fas fa-check" /> Save
            </Button>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
}
export default LOCATION_CODE_CRUD;
// const getState = ({CreateDocumentForm}) => {
//     return {
//         CreateDocumentForm
//     };
// }
// const mapDispatcToProps = dispatch => ({...bindActionCreators({

// },dispatch),dispatch})
// export default connect(getState,mapDispatcToProps)(ADDITIONAL_DOCUMENTS);
